import { getResumes, uploadResume, deleteResume } from './resumes';
import { 
  review, 
  generateCoverLetter, 
  generateInterviewPrep, 
  generateCommunications, 
  rewriteResume,
  extractJobMetadata 
} from './ai';
import { 
  getSavedOutputs, 
  getSavedOutput, 
  saveOutput, 
  updateSavedOutput, 
  deleteSavedOutput 
} from './outputs';
import { clearAll } from './storage';

export const api = {
  getResumes,
  uploadResume,
  deleteResume,
  
  review,
  generateCoverLetter,
  generateInterviewPrep,
  generateCommunications,
  rewriteResume,
  extractJobMetadata,
  
  getSavedOutputs,
  getSavedOutput,
  saveOutput,
  updateSavedOutput,
  deleteSavedOutput,
  
  clearAll
};
